import VehicleTaskForm from './VehicleTaskForm';

/** IAD — Vehicle registration & title (settlement) */
export default function Frame50() {
  return <VehicleTaskForm taskKind="registration" />;
}
